import { z } from 'zod'

export const applicationSchema = z.object({
  name: z.string().min(1, 'Name is required').max(191),
  code: z
    .string()
    .min(1, 'Code is required')
    .max(50)
    .regex(/^[a-z0-9_]+$/, 'Code may only contain lowercase letters, numbers, and underscores'),
  description: z.string().optional(),
  active: z.boolean(),
})

export type ApplicationFormData = z.infer<typeof applicationSchema>
